import { SxProps } from '@mui/material';

export const HelpCenterFrameSx: SxProps = {
	width: '100%',
};

export const HelpCenterTitleSx: SxProps = {
	fontSize: { xs: 'var(--font-size-lg)', md: 'var(--font-size-xl)' },
	fontWeight: 800,
	textTransform: 'uppercase',
	marginBottom: '8px',
};

export const HelpCenterDescriptionSx: SxProps = {
	fontSize: 'var(--font-size-body)',
	marginBottom: '20px',
};

export const HelpCenterGridSx: SxProps = {
	display: { xs: 'flex' },
	gap: { xs: '10px' },
	justifyContent: { xs: 'flex-start' },
	alignItems: { xs: 'flex-start' },
	width: { xs: '100%' },
	scrollbarWidth: 'thin',
	overflowY: { xs: 'scroll', sm: 'auto' },
	pb: { xs: '10px', md: '10px', lg: 0 },
	zIndex: 99,
	marginBottom: { xs: '24px', sm: '25px' },
};
